import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import {Map as MapComponent} from './Map.js';
import { DoctorCarousel } from "./DoctorCarousel.js"
import colors from './colors.js';

const useStyles = makeStyles(theme => ({
  smallScreenRoot: {
    height: "100vh", /* Use vh as a fallback for browsers that do not support Custom Properties */
    height: `calc(var(--vh, 1vh) * 100 - ${theme.spacing(8)}px)`,
    backgroundColor: colors.blue,
    flexDirection: 'column',
    display: 'flex',
  },
  doctorListHeader: {
    margin: 0,
    fontSize: '16px',
    color: colors.grey,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  smallDoctorListContainer: {
    padding: theme.spacing(3),
    paddingRight: 0,
    width: '100%',
    paddingTop: 0,
  },
  smallMapContainer: {
    display: 'flex',
    height: '100%',
    flex: 'grow',
  },
  doctorListHeaderDivider: {
    backgroundColor: colors.grey,
  },
  headerContainer: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    paddingTop: 0,
  },
  doctorListHeaderText: {
    paddingTop: theme.spacing(2),
    color: colors.pink
  },
  doctorListHeaderSubtext: {
    color: colors.pink,
    fontSize: "12px",
  }
}));


export const MobileWebMapView = (props) => {
  const classes = useStyles();
  return (
    <div ref={props.mapRef} className={classes.smallScreenRoot}>
      <div className={classes.headerContainer}>
        <Typography className={classes.doctorListHeaderText} align="left" variant="h4" paragraph>
          {props.mapCopy.mapTitle}
        </Typography>
        <Typography className={classes.doctorListHeaderSubtext} align="left" variant="body1" paragraph>
          <i>
            {props.mapCopy.mapTitleSubtextMobile}
          </i>
        </Typography>
      </div>
      <div className={classes.smallMapContainer}>
        <MapComponent
          center={props.currentCenter}
          zoom={props.currentZoom}
          doctors={props.doctorsList}
          handleCenterChange={props.handleCenterChange}
          onMouseOver={d => props.setHoverDoctor(d.id)}
          onMouseOut={() => {
            props.setHoverDoctor(null);
          }}
          setZoom={props.setZoom}
          setLastZoom={props.setLastZoom}
          lastZoom={props.lastZoom}
          onClick={props.selectDoctor}
          hoverDoctor={props.hoverDoctor}
          selectedDoctor={props.selectedDoctor}
        />
      </div>
      <div className={classes.smallDoctorListContainer}>
        <DoctorCarousel
          doctorsList={props.doctorsList}
          classes={classes}
          setHoverDoctor={id => { props.setHoverDoctor(id) }}
          selectDoctor={d => { props.setSelectedDoctorId(d.id) }}
        />
      </div>
    </div>
  )
}
